// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"545720b7","732":"e85f8fcc","977":"825522ac"}[chunkId] + ".chunk.js";
};